export default __webpack_public_path__ + "static/media/yotei_mock.709db291.png";